import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Headers, Http, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ResponseContentType } from '@angular/http';

import { SessionService } from './session.service';
import { Field } from '../models';

@Injectable()
export class ApiService {
    constructor(
        private http: Http,
        private sessionService: SessionService
    ) { }

    //public $A$P$I_$K$E$Y: string = "A0A012EB-4F57-456B-9BF9-3EFE96DE1282";
    // add headers before making the request
    private setHeaders(content_type = "json"): Headers {
        const headersConfig = {
            'Cache-Control': 'no-store, no-cache, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': 0
        };

        if (content_type == "json") {
            headersConfig['Content-Type'] = 'application/json';
        } else if (content_type == "raw") {
            headersConfig['Content-Type'] = 'text/plain';
        } else if (content_type == "file") {
            headersConfig['Content-Type'] = 'application/x-www-form-urlencoded';
        } else if (content_type == "blob") {

        }

        headersConfig['withCredentials'] = true;
        if (this.sessionService.getSessionToken()) {
            headersConfig['Authorization'] = `Token ${this.sessionService.getSessionToken()}`;
        } 

        // if (this.sessionService.getSessionToken()) {
        //     headersConfig['Authorization'] = `Token ${this.sessionService.getSessionToken()}`;
        //     //headersConfig['S$N_A$P$I_K$E$Y'] = this.$A$P$I_$K$E$Y;
        // }
        return new Headers(headersConfig);
    }

    private processReponseError(error: any) {
        console.log("API Response Error", error);
        //console.log(error);
        return Observable.throw(error.json());
    }

    // no point logging as it is async calls
    logRequest(method, url) {
        //this.sessionService.log({method: method, url: url});
    }

    isObject(value): boolean {
        return value && typeof value === 'object' && value.constructor === Object;
    }

    AddAdditionalSearchParams(params: URLSearchParams): URLSearchParams {
        var ot = this.sessionService.getOneTimeToken();
        if (this.isObject(ot)) {
            params["ot"] = ot;
        }
        return params;
    }

    web3_get(path: string, params: URLSearchParams = new URLSearchParams(), bResetIdleTime: boolean = true): Observable<any> {
        var url = `${environment.web3_api_url}${path}`;
        this.logRequest("get", url);
        params = this.AddAdditionalSearchParams(params);
        return this.http.get(url, { withCredentials: true, headers: this.setHeaders(), search: params })
            .catch(this.processReponseError)
            .map((res: Response) => {
                if (bResetIdleTime) this.sessionService.resetUserIdleTimer();
                return res.json();
            });
    }

    get(path: string, params: URLSearchParams = new URLSearchParams(), bResetIdleTime: boolean = true): Observable<any> {
        var url = `${environment.api_url}${path}`;
        this.logRequest("get", url);
        params = this.AddAdditionalSearchParams(params);
        return this.http.get(url, { withCredentials: true, headers: this.setHeaders(), search: params })
            .catch(this.processReponseError)
            .map((res: Response) => {
                if (bResetIdleTime) this.sessionService.resetUserIdleTimer();
                return res.json();
            });
    }

    put(path: string, body: Object = {}, content_type = "json", params: any = null): Observable<any> {
        var url = `${environment.api_url}${path}`;
        this.logRequest("put", url);
        return this.http.put(url, JSON.stringify(body), { withCredentials: true, headers: this.setHeaders(content_type), params: params })
            .catch(this.processReponseError)
            .map((res: Response) => {
                this.sessionService.resetUserIdleTimer();
                return res.json();
            });
    }

    post(path: string, body: Object = {}, content_type = "json", params: any = null): Observable<any> {
        var url = `${environment.api_url}${path}`;
        this.logRequest("post", url);
        return this.http.post(url, JSON.stringify(body), { withCredentials: true, headers: this.setHeaders(content_type), params: params })
            .catch(this.processReponseError)
            .map((res: Response) => {
                this.sessionService.resetUserIdleTimer();
                try {
                    return res.json();
                } catch (e) {
                    return res.json();
                }
            });
    }

    postFile(path: string, data: FormData): Observable<any> {
        var url = `${environment.api_url}${path}`;
        this.logRequest("postFile", url);
        return this.http.post(url, data, { withCredentials: true, headers: this.setHeaders(null) })
            .catch(this.processReponseError)
            .map((res: Response) => {
                this.sessionService.resetUserIdleTimer();
                return res.json();
            });
    }

    delete(path): Observable<any> {
        var url = `${environment.api_url}${path}`;
        this.logRequest("delete", url);
        return this.http.delete(url, { withCredentials: true, headers: this.setHeaders() })
            .catch(this.processReponseError)
            .map((res: Response) => {
                this.sessionService.resetUserIdleTimer();
                return res.json();
            });
    }

    // common view methods
    getViewItem(view: string, item_ID: number): Observable<any> {
        return this.get("/views/" + view + "/" + item_ID).map(
            (result) => {
                return result;
            }
        )
    }

    processActionOnViewItems(view: string, action: string, params: any) {
        return this.get(`/views/${view}/actions/${action}`, params).map(
            (result) => { return result; }
        )
    }

    processActionOnViewItem(view: string, id: number, action: string, params: any) {
        return this.get(`/views/${view}/${id}/actions/${action}`, params).map(
            (result) => { return result; }
        )
    }

    saveViewItem(view: string, id: number, formFields: Array<Field<any>>, params: any = null) {
        if (id == 0) {
            return this.put("/views/" + view, formFields, "raw", params).map(
                (result) => { return result; }
            )
        } else {
            return this.post("/views/" + view + "/" + id, formFields, "raw", params).map(
                (result) => { return result; }
            )
        }
    }

    getViewData(view, params, bResetIdleTimer: boolean = true): Observable<any> {
        return this.get("/views/" + view, params, bResetIdleTimer).map(
            (result) => {
                return result;
            }
        )
    }

    getModelData(model, params, bResetIdleTimer: boolean = true): Observable<any> {
        var url = `/models/${model}`;
        return this.get(url, params, bResetIdleTimer).map(
            (result) => {
                return result;
            }
        )
    }


    processMeetingAction(action, data, content_type: string = "raw", params?: any): Observable<any> {
        return this.post(`/models/meeting/action/${action}`, data, content_type, params).map(
            (result) => {
                return result;
            }
        )
    }

    processDealAction(action, data, content_type?: string, params?: any): Observable<any> {
        return this.post(`/models/deal/action/${action}`, data, content_type, params).map(
            (result) => {
                return result;
            }
        )
    }

    processCaseAction(action, data, content_type: string = "raw", params?: any): Observable<any> {
        return this.post(`/models/case/action/${action}`, data, content_type, params).map(
            (result) => {
                return result;
            }
        )
    }

    processUserActionOnPost(action, data, content_type: string = "raw", params?: any): Observable<any> {
        return this.post(`/models/user/action/${action}`, data, content_type, params).map(
            (result) => {
                return result;
            }
        )
    }

    processUserActionOnGet(action:string, params?: any): Observable<any> {
        return this.get(`/models/user/action/${action}`, params).map(
            (result) => {
                return result;
            }
        )
    }

    loadSfBiDashboards(params: any): Observable<any> {
        return this.get(`/bi/sf/dashboards`, params).map(
            (result) => {
                return result;
            }
        )
    }

    getAuthToken(): Observable<any> {
        return this.get(`/admin/auth_token`).map(
            (result) => {
                return result;
            }
        )
    }

    translateEmailTemplate(template_ID, record_type, item_id): Observable<any> {
        return this.get(`/models/email_templates/${template_ID}/translate/${record_type}/${item_id}`).map(
            result => {
                return result;
            }
        )
    }

    sendEmailTemplate(template, attachments: any[], params = null) {
        var attachment_IDs: any[] = [];
        if (attachments) {
            attachments.forEach(a => { attachment_IDs.push(a.ID); });
        }
        if (params == null) params = {};
        params.attachment_IDs = attachment_IDs.join(",");
        return this.put(`/models/email_templates/send`, template, "json", params).map(
            result => {
                return result;
            }
        )
    }

    processSchedulingActionOnGet(scheduler:string, action:string, params?: any): Observable<any> {
        return this.get(`/scheduling/${scheduler}/actions/${action}`, params).map(
            (result) => {
                return result;
            }
        )
    }

    processSchedulingActionOnPost(scheduler, action, data, content_type?: string): Observable<any> {
        return this.post(`/scheduling/${scheduler}/actions/${action}`, data, content_type).map(
            (result) => {
                return result;
            }
        )
    }

    getCustomValue(field_name: string, item_type: string = "client_preference", item_id: number = 0): Observable<any> {
        let params: any = {
            it: item_type,
            iid: item_id,
            fn: field_name
        }

        return this.get("/models/custom_values", params).map(
            (result) => {
                if (result && result.length > 0) {
                    return result[0].field_value;
                }
                return null;
            }
        )        
    }

    downloadFile(file:any) {
        // var url = `${environment.sn_url}/services/FileDownload.aspx?FLUID=${file.storage_key}`;
        var url = `${environment.api_url}/models/file/download/${file.ID}`;
        return this.http.get(url, { withCredentials: true, responseType: ResponseContentType.Blob, headers: this.setHeaders('blob'), search: new URLSearchParams() })
            .subscribe(response => {
                const blob = new Blob([response.blob()], { type: response != null && response.headers != null ? response.headers.get('Content-Type') : '' });
                const a = document.createElement('a');
                const objectUrl = URL.createObjectURL(blob);
                a.href = objectUrl;
                a.download = file.filename;   // or extract from Content-Disposition
                a.click();
                URL.revokeObjectURL(objectUrl);
            }
        );
    }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/api.service.ts